import { useNavigate } from 'react-router-dom';
import { useFeatureFlag } from '@/hooks/featureFlags';
import { SegmentedPipelineView } from '@/features/pipelines/components/SegmentedPipelineView';
import { PageHeader } from '@/components/layout/PageHeader';

export function PipelineView() {
  const navigate = useNavigate();
  const pipelineEnabled = useFeatureFlag('funil.pipeline.view');

  if (!pipelineEnabled) {
    return (
      <>
        <PageHeader title="Pipeline" subtitle="Vendas" onBack={() => navigate('/vendas')} />
        <div className="flex-1 bg-[#f8fafc] dark:bg-[#141414] transition-colors duration-300">
          <div className="w-full max-w-[2000px] mx-auto px-3 sm:px-4 md:px-6 xl:px-8 py-6">
            <div className="rounded-[24px] bg-white/60 dark:bg-zinc-950/60 backdrop-blur-lg border border-[rgba(15,118,110,0.08)] dark:border-white/5 p-8 text-center">
              <p className="text-gray-600 dark:text-gray-400">Pipeline ainda não está disponível nesta versão.</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  return <SegmentedPipelineView />;
}

export default PipelineView;
